import { useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { miscUiState } from '../../../globalState'
// import { tabListState } from '../../PlayerListOverlayProvider'
import { chatVisibilityState } from '../../Chat'
import { MenuSettingsIcon, ChatFilledIcon } from './PlayerIcons'
// import { BurgerIcon } from './PlayerIcons'
import styles from './TopMenu.module.css'

/**
 * Top-centre control row: settings / players list / chat, each tile labelled
 * with the key that does the same thing. Lives in #player-root — unscaled, so
 * sizes are real screen pixels.
 *
 * The players list tile is held back.
 */

type Props = {
  onTogglePackets: () => void
  onOpenSettings: () => void
}

function toggleUI () {
  miscUiState.showUI = !miscUiState.showUI
}

export default function TopMenu ({ onTogglePackets, onOpenSettings }: Props) {
  // const { isOpen: tabListOpen } = useSnapshot(tabListState)
  const { hidden: chatHidden } = useSnapshot(chatVisibilityState)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.target instanceof HTMLInputElement) || (e.target instanceof HTMLTextAreaElement)) return
      switch (e.key.toLowerCase()) {
        case 'p':
          onTogglePackets()
          break
        case 'i':
          toggleUI()
          break
      }
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onTogglePackets])

  return (
    <div
      className={styles.root}
      data-replay-ui
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <div className={styles.group}>
        <button
          type="button"
          className={styles.trigger}
          aria-label="Настройки"
          title="Настройки"
          onClick={onOpenSettings}
        >
          <MenuSettingsIcon size={16} />
          <span className={styles.triggerLabel}>esc</span>
        </button>
        {/* <button
          type="button"
          className={[styles.trigger, tabListOpen && styles.triggerActive].filter(Boolean).join(' ')}
          aria-label="Список игроков"
          title="Список игроков"
          aria-pressed={tabListOpen}
          onClick={() => { tabListState.isOpen = !tabListState.isOpen }}
        >
          <BurgerIcon size={16} />
          <span className={styles.triggerLabel}>tab</span>
        </button> */}
        <button
          type="button"
          className={styles.trigger}
          aria-label={chatHidden ? 'Показать чат' : 'Скрыть чат'}
          title={chatHidden ? 'Показать чат' : 'Скрыть чат'}
          aria-pressed={!chatHidden}
          onClick={() => { chatVisibilityState.hidden = !chatVisibilityState.hidden }}
        >
          <ChatFilledIcon size={16} />
          <span className={styles.triggerLabel}>T</span>
        </button>
      </div>
    </div>
  )
}
